import React from 'react';

const MobileAppointed = () => {
    return (
        <div>
            MobileAppointed
            MobileAppointed
        </div>
    );
};

export default MobileAppointed;